import React, { Component } from 'react';
import axios from 'axios';
import spinner from '../../images/loading-spinner.gif';
// import '../../CSS/feedback.css';
import { translate } from 'react-i18next';

let cancelToken;
class FormProspecto extends Component{

    constructor(props) {
        super(props);
        this.state ={
            disabled: true,
            formClient: true,
            sendPost: false
        }
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    handleInputChange = (event) => {
        let input = event.target.name;
        this.setState({[input]: event.target.value, disabled: false, sendPost: false})
    }

    handleSubmit = (event) => {
        event.preventDefault();
        let params = this.state;
        params.token_id = this.props.getTokenId;
        params.id = this.props.info.pollId
        params.centro_id = this.props.info.centro_id
        this.setState({disabled: true, sendPost: true})
        if (params.id > 0) {
            this.props.post('/improvement/saveClient', params, (response) => this.handleSuccesClient(response), (error) => this.handleErrorClient(error), cancelToken )
        }
    }

    handleSuccesClient = (response) => { 
        this.setState({formClient: false, sendPost: false}) 
    }

    handleErrorClient = (codeError, param_uno, param_dos, msgError) => { 
        this.setState({formClient: false, sendPost: false}) 
    }

    handleClickSave = (event) => {
        // this.setState({disabled: true})
    }

    handleInputChangeCheck = (event) => {
        if (event.target.checked) {
            this.setState({formClient: false, sendPost: false})
        }
    }

    render() {
        return(
            <div>
                {this.state.formClient ? this.formClient() : this.messageForm() }
            </div>
        )
    }

    
    formClient (){
        const { t } = this.props;
        return (
            <div>
                <div>
                    <label htmlFor="quetion">
                        <i id="text_form_client">{t('dashboard.question.botooms.skip')}</i>
                        <input id="check_form" type="checkbox" value="0" onChange={this.handleInputChangeCheck}/>
                    </label>
                </div>
                <form id="form_user" method="post" onSubmit={this.handleSubmit}>
                    <div className="row" style={form}>
                        <div className="col-md-12 text-center">
                            <h2 id="subtitle-section">
                            ¿Alguien que conoces necesita una oficina?<b>Coloca los datos de tu referido aquí </b> y recibe una sorpresa
                                </h2>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="name">{t('dashboard.question.data.fullname')}<i>*</i></label>
                                <input className="form-control" id="name" name="nombre" placeholder="Nombre" type="text" required onChange={this.handleInputChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">{t('dashboard.question.data.mail')}<i>*</i></label>
                                <input className="form-control" id="email" name="email" placeholder="example@iosoffices.com" type="email" required onChange={this.handleInputChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">{t('dashboard.question.data.comment')}</label>
                                <textarea className="form-control" placeholder="Comentarios" name="comentarios" onChange={this.handleInputChange} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="name">{t('dashboard.question.data.office')}</label>
                                <input className="form-control" id="club_empresa" name="empresa" placeholder="Empresa" type="text"  onChange={this.handleInputChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="phone">{t('dashboard.question.data.phone')}<i>*</i></label>
                                <input className="form-control" id="phone" name="telefono" placeholder="Teléfono"  type="tel" required onChange={this.handleInputChange} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 text-center">
                        <button className="btn_form_poll" type="submit" onClick={this.handleClickSave}  readOnly={this.state.disabled}> {this.state.sendPost ? t('dashboard.question.botooms.send') : t('dashboard.question.botooms.save')} </button>
                        <img id="loadingImg" className={this.state.sendPost ? "" : "hidden"} src={spinner}/>
                    </div>
                </form>
            </div>
        )
    }

    messageForm (){
        return (
            <div className="alert alert-info col-md-12">
                <center>
                    <p>Agradecemos tu tiempo. Nos ponemos a sus órdenes y reiteramos el compromiso de servirte cada día mejor.</p>
                </center>
            </div>
        )
    }

}
export default translate('common')(FormProspecto);
const form = { border: '1px solid #dfdede'}


// WEBPACK FOOTER //
// ./src/guest/improvement/FormProspecto.js